const siteTariffsModule = {
  state: {
    current_tariff: null
  },
  mutations: {
    setCurrentSiteTariff (state, data) {
      state.current_tariff = data
    },
  },
  getters: {
    getCurrentSiteTariff: (state) => {
      return state.current_tariff
    },
  }
}

export default siteTariffsModule



// WEBPACK FOOTER //
// ./src/store/modules/site_tariffs.js